var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarGraph',{ref:"barGraph",staticClass:"c-plot c-bar-chart-view",attrs:{"data":_vm.trace,"plot-axis-title":_vm.plotAxisTitle},on:{"subscribe":_vm.subscribeToAll,"unsubscribe":_vm.removeAllSubscriptions}})}
var staticRenderFns = []

export { render, staticRenderFns }